import { Box, BoxProps, ColorOptions, IconButton, Loader, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useNavigation, useRoute } from '@react-navigation/native'
import debounce from 'lodash/debounce'
import { useEffect, useState } from 'react'
import { Dimensions, FlatList } from 'react-native'
import { titleCase } from '../../../comps/CustomHeader/headerFunctionHelpers'
import { HeaderLeft } from '../../../comps/MobileCustomHeader/HeaderLeft'
import { useLazyApiData, useStores } from '../../../data/store'
import { Routes } from '../../../nav/routes'
import { BillerCategoryMasterId, operatorKeyExtractor } from '../../../util/billPaymentUtil'
import { Colors } from '../../../util/util'
import { OperatorItem } from '../OperatorList/Item'
import { SearchBar } from '../SearchBar'
import { InstituteListSectionListtsx } from './InstituteListSectionList'
import styles from './styles'
const InstituteList = () => {
  const navigation = useNavigation()
  const [searchText, setSearchText] = useState('')
  const params: any = useRoute().params ?? {}

  navigation.setOptions({
    gestureEnabled: true,
    headerLeft: () => <HeaderLeft />,
    headerStyle: { borderBottomColor: 'rgba(0,0,0,0)' },
    headerTintColor: '#fff',
    headerBackVisible: true,
    headerTransparent: true,
    title: titleCase(params?.title ?? ''),
    headerTitleStyle: {
      fontSize: 18,
      fontFamily: 'JioType-Bold',
    },
  })

  const [selectedBiller, setSelectedBiller]: any = useState({})
  const {
    getOperatorsList,
    currentNewsPageStarted,
    currentNewsPageFetched,
    seachBillers,
    updateBillfetchMetaData,
    getAuthenticatorList,
  } = useStores((root) => ({
    getOperatorsList: root.billPayments.getOperatorList,
    seachBillers: root.billPayments.seachBillersApi,
    updateBillfetchMetaData: root.billPayments.updateBillfetchMetaData,
    currentNewsPageStarted: root?.billPayments.transaction.currentNewsPageStarted,
    currentNewsPageFetched: root?.billPayments.transaction.currentNewsPageFetched,
    getAuthenticatorList: root.billPayments.getAuthenticatorListApi,
  }))
  const allOperators = getOperatorsList(BillerCategoryMasterId.EducationFee)
  const [seachBillersApi, { state: apiStatus, data: apiData }] = useLazyApiData(seachBillers)
  useEffect(() => {
    seachBillersApi('', 1, true)
  }, [seachBillersApi])

  const [getAuthenticatorData, { state: authenticatorLoading }] = useLazyApiData(getAuthenticatorList)

  const upadteBillFetchData = (item: any) => {
    const auth = item?.authenticators ?? null
    updateBillfetchMetaData({
      billerMasterId: item?.id ?? 0,
      authenticators: auth ? [...auth] : [],
      shortName: item?.shortName ?? '',
    })
    setSelectedBiller(item)
    getAuthenticatorData(item?.id)
  }
  useEffect(() => {
    if (authenticatorLoading === 'fulfilled') {
      navigation.navigate(Routes.AUTH_INPUT as never, { title: selectedBiller?.shortName } as never)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticatorLoading, navigation])

  const renderItem = ({ item }: any) => {
    return <OperatorItem item={item} onPress={upadteBillFetchData} />
  }

  const onChangeText = (text: string) => {
    setSearchText(text)
    callApi(text)
  }

  const callApi = debounce((value: string) => {
    console.log('****** value: ', value.length)
    if (value.length > 2) {
      seachBillersApi(value, 1, true)
    } else if (value.length === 0) {
      seachBillersApi('', 1, true)
    }
  }, 50)

  const onEndReached = () => {
    console.log(currentNewsPageFetched + '********* onEndReached: ' + Math.ceil(allOperators.length / 20))
    if (
      currentNewsPageFetched !== 0 &&
      currentNewsPageFetched === Math.ceil(allOperators.length / 20) &&
      currentNewsPageStarted === currentNewsPageFetched
    ) {
      seachBillersApi(searchText, currentNewsPageFetched + 1, false)
    }
  }
  const renderFooter = () => {
    if (allOperators.length > 1 && apiStatus === 'pending') {
      return (
        <Box justifyContent="center" alignItems="center" paddingBottom={8}>
          <Loader type="small" color="PRIMARY" />
          <Text value="Loading more" {...styles.titleEmpty} />
        </Box>
      )
    }
    if (
      allOperators.length > 1 &&
      (apiStatus === 'rejected' || currentNewsPageStarted > currentNewsPageFetched) &&
      currentNewsPageFetched > 1
    ) {
      return (
        <Box justifyContent="center" alignItems="center" paddingBottom={8}>
          <Text {...styles.titleEmpty}>{apiData?.message ?? 'Something went wrong!'}</Text>
          <Spacer size={8} direction="vertical" />
          <IconButton
            onPress={() => {
              seachBillersApi(searchText, currentNewsPageFetched + 1, false)
            }}
            testID={'retry'}
            size="MEDIUM"
            id="ICON_REFRESH"
          />
        </Box>
      )
    }
    return null
  }

  const getOperators = () => {
    if (allOperators.length < 1) {
      return []
    }
    return allOperators
  }

  const deviceWidth = Dimensions.get('window').width

  return (
    <Box flex={1} backgroundColor="SECONDARY" position={'relative'} pt={70}>
      <Box {...style.listWrapper} backgroundColor={'WHITE'} pb={0}>
        <ModBox f={1} justify="center" align="center" show={apiStatus === 'pending'}>
          <Loader />
          <Spacer size={10} direction="vertical" />
          <Text color={Colors.BLACK_14 as ColorOptions} fontFamily="SourceSans3-SemiBold" fontSize={14}>
            Loading...
          </Text>
        </ModBox>

        <ModBox show={apiStatus !== 'pending'} {...styles.contantViewStyle} backgroundColor="WHITE">
          <Box paddingHorizontal={16} paddingBottom={8} width={deviceWidth}>
            <SearchBar
              onChange={onChangeText}
              value={searchText}
              placeholder="Search for Institution"
              theme={{ bodyBgColor: '#fff', bodyTextColor: '#B5B5B5' as ColorOptions }}
            />
          </Box>
          <Box ph={25} f={1} w={deviceWidth}>
            {false && (
              <FlatList
                testID={'operatorList'}
                contentContainerStyle={styles.containerList}
                keyboardDismissMode={'on-drag'}
                keyboardShouldPersistTaps={'always'}
                data={getOperators()}
                keyExtractor={operatorKeyExtractor}
                renderItem={renderItem}
                ListFooterComponent={renderFooter}
                onEndReachedThreshold={0.75}
                onEndReached={onEndReached}
              />
            )}
            <InstituteListSectionListtsx
              renderOperatorItem={renderItem}
              data={getOperators()}
              onEndReached={onEndReached}
            />
          </Box>
        </ModBox>
      </Box>
    </Box>
  )
}

const style = {
  listWrapper: {
    flex: 1,
    backgroundColor: 'WHITE',
    pv: 25,
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25,
    width: '100%',
    zIndex: 4,
    overflow: 'auto',
  } as BoxProps,
}

export default InstituteList
